import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  Box,
} from "@mui/material";
import "./styles.css";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import LoopOutlinedIcon from "@mui/icons-material/LoopOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import savedSuccessfullyImage from "../../assets/savedSuccessfullyImage.svg";
import fetchStatus from "../../fetchApi/fetchStatus";
import CustomLoader from "../CustomLoader/CustomLoader";
import useParamValues from "../../utils/useParamValues";
import { useTranslationSetup } from "../../utils/useTranslationSetup.js";
import { UrlConstants } from "../../utils/CommonUtils/constants.js";
import { SCREENS } from "../../utils/CommonUtils/screenConstants.js";

const SaveResultDialogBox = ({
  setActiveScreen,
  isDialogOpen,
  setDialogOpen,
  setProcessedData,
  assessmentId,
  setAudioBlob,
  setHideSlider,
  uploadAudioStatus,
  setUploadAudioStatus,
  setStudentName,
  isAudioUploading,
  setAudioUploading,
  setShowErrorDialog,
  setOrfResultStatus,
  setSelectedLaguage,
  setSaveClicked,
}) => {
  const { organisation } = useParamValues();
  const { t } = useTranslationSetup();

  const handleReturnToAssessment = () => {
    setDialogOpen(false);
    setHideSlider(false);
    setAudioBlob(null);
    setUploadAudioStatus(null);
    setAudioUploading(false);
    setSaveClicked(false);
  };

  const handleReturnToInputPage = () => {
    setDialogOpen(false);
    setActiveScreen(SCREENS.RENDER_VS_WELCOME_SCREEN);
    setHideSlider(false);
    setAudioBlob(null);
    setUploadAudioStatus(null);
    setAudioUploading(false);
    setSaveClicked(false);
    setStudentName("");
    setSelectedLaguage(null);
  };

  return (
    <Dialog
      className="save-result"
      open={isDialogOpen}
      aria-labelledby="save-result-title"
      aria-describedby="save-result-dialog-description"
    >
      {isDialogOpen &&
      isAudioUploading &&
      uploadAudioStatus !== "ERR_INTERNET_DISCONNECTED" ? (
        <Box className="custom-loader-box">
          <CustomLoader />
          <Box className="uploading-audio-text">
            {t("please_wait_while_uploading_audio")}
          </Box>
        </Box>
      ) : isDialogOpen && uploadAudioStatus === "COMPLETED" ? (
        <DialogTitle
          id="save-result-dialog-title"
          style={{
            backgroundImage: `url(${savedSuccessfullyImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            marginTop: "0px",
          }}
        >
          <CheckCircleIcon className="check-circle-icon" />
          <Typography className="saved-successfully-text">
            {t("saved_successfully")}
          </Typography>
          <Typography className="saved-successfully-desc">
            {t("saved_successfully_description")}
          </Typography>
        </DialogTitle>
      ) : isDialogOpen && uploadAudioStatus === "ERROR" ? (
        <Box className="error-outlined-container">
          <ErrorOutlineOutlinedIcon className="error-outlined-icon" />
        </Box>
      ) : (
        <Box className="error-outlined-container">
          <ErrorOutlineOutlinedIcon className="error-outlined-icon" />
        </Box>
      )}
      <DialogContent>
        <DialogContentText
          id="save-result-dialog-description"
          style={{ textAlign: "center" }}
        >
          {(isDialogOpen && uploadAudioStatus === "COMPLETED") ||
          (isAudioUploading &&
            uploadAudioStatus !== "ERR_INTERNET_DISCONNECTED") ? (
            <>
              <Button
                variant="contained"
                startIcon={<AssignmentOutlinedIcon />}
                className="see-result-button"
                disabled={isAudioUploading}
                onClick={() => {
                  setDialogOpen(false);
                  setActiveScreen(SCREENS.RENDER_ORF_RESULT_LOADINGSCREEN);
                  fetchStatus(
                    UrlConstants.BASE_URL +
                      UrlConstants.BASE_PATH_URL +
                      UrlConstants.ASSESSMENT +
                      `/${assessmentId}?get_audio=false`
                  )
                    .then((data) => {
                      if (data.status === "COMPLETED") {
                        setOrfResultStatus(data.status);
                        if (organisation === "vopa") {
                          setProcessedData(data.data.result);
                        } else {
                          setProcessedData(data.data);
                        }
                        setActiveScreen(SCREENS.RENDER_ORF_RESULT_SCREEN);
                      } else if (data.status === "UNDETERMINED") {
                        setOrfResultStatus(data.status);
                        setShowErrorDialog(true);
                      } else if (data.status === "FAILED") {
                        setOrfResultStatus(data.status);
                        setShowErrorDialog(true);
                      } else if (data.status === "ERROR") {
                        setOrfResultStatus(data.status);
                        setShowErrorDialog(true);
                      }
                    })
                    .catch((error) => {
                      setOrfResultStatus(error.status);
                    });
                }}
              >
                {t("see_result")}
              </Button>
            </>
          ) : isDialogOpen && uploadAudioStatus === "ERROR" ? (
            <Box>
              <Typography className="something-went-wrong-text">
                {t("something_went_wrong")}
              </Typography>
              <Box className="retake-button-box">
                <Button
                  variant="contained"
                  startIcon={<LoopOutlinedIcon className="retake-icon" />}
                  className="retake-button"
                  disableElevation
                  onClick={handleReturnToAssessment}
                >
                  {t("retake")}
                </Button>
              </Box>
              <Box className="new-student-button-box">
                <Button
                  variant="text"
                  startIcon={
                    <KeyboardReturnIcon className="key-board-return-icon" />
                  }
                  className="new-student-button"
                  onClick={handleReturnToInputPage}
                  disableElevation
                >
                  {t("new_student")}
                </Button>
              </Box>
            </Box>
          ) : (
            <Box>
              <Typography className="something-went-wrong-text">
                {t("something_went_wrong")}
              </Typography>
              <Box className="retake-button-box">
                <Button
                  className="retake-button"
                  variant="contained"
                  startIcon={<LoopOutlinedIcon className="retake-icon" />}
                  disableElevation
                  onClick={handleReturnToAssessment}
                >
                  {t("retake")}
                </Button>
              </Box>
              <Box className="new-student-button-box">
                <Button
                  variant="text"
                  startIcon={
                    <KeyboardReturnIcon className="key-board-return-icon" />
                  }
                  className="new-student-button"
                  onClick={handleReturnToInputPage}
                  disableElevation
                >
                  {t("new_student")}
                </Button>
              </Box>
            </Box>
          )}
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};
export default SaveResultDialogBox;
